<template>
  <div>
    <v-row dense no-gutters cols="12">      
      <v-col cols="5">
        <v-row dense>
          <v-col cols="12">
            <re_radioset :value="wizardData.sales_relative" field="sales_relative" @updateData="updateData"/>
          </v-col>
        </v-row>                
        <div v-if="wizardData.sales_relative===true">
          <hsnp_wizard_step_02_sales_relative :wizardData="wizardData" @updateData="updateData" class="ml-3"/>
        </div>
        <div v-else>
          <hsnp_wizard_step_02_sales_exact :wizardData="wizardData" @updateData="updateData" class="ml-3"/>
        </div>
      </v-col>
      <v-col cols="6" class="mt-3">
        <weekdays :days="wizardData.sales_days" field="sales_days" color="primary" @updateData="updateData" class="ml-3"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <div class="mb-1 sub-title">Purchase price</div>
        <v-divider></v-divider>        
        <v-radio-group dense v-model="wizardData.sales_purchase_auto_update" v-on:change="updateSalesPurchaseAuto" class="mt-0">
          <!-- <v-radio key='0' label="Automatically update purchase prices using the change parameters" :value=0></v-radio> -->
          <v-radio key='2' label="Automatically update purchase price using the existing margin" :value=2></v-radio>
          <v-radio key='1' label="Do not update purchase price (results in new margin)" :value=1></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="4">
        <div class="mb-1 sub-title">Minimum purchase price</div>
        <v-divider></v-divider>        
        <v-radio-group dense v-model="wizardData.sales_minpurchase_auto_update" v-on:change="updateMinPurchaseAuto" class="mt-0">
          <v-radio key='0' label="Automatically update minimum purchase prices using the change parameters" :value=0></v-radio>
          <v-radio key='1' label="Do not update mimimum purchase price" :value=1></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="4">
        <div class="mb-1 sub-title">Week price</div>
        <v-divider></v-divider>
        <v-radio-group dense v-model="wizardData.sales_weekprice_auto_update" v-on:change="updateSalesWeekpriceAuto" class="mt-1">
          <v-radio key='0' label="Automatically update week prices using the change parameters" :value=0></v-radio>
          <v-radio key='1' label="Do not update week prices" :value=1></v-radio>
        </v-radio-group>
      </v-col>            
    </v-row>       

  </div>      
</template>

<script>
  import weekdays from '@/components/huis/hspt/ui/weekdays.vue';
  import re_radioset from '@/components/huis/hspt/ui/re_radioset.vue';
  import hsnp_wizard_step_02_sales_relative from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_sales_relative.vue';
  import hsnp_wizard_step_02_sales_exact from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_sales_exact.vue';

  export default {
    props: {
      wizardData: Object
    },
    components: {
      weekdays,
      re_radioset,
      hsnp_wizard_step_02_sales_relative,
      hsnp_wizard_step_02_sales_exact,
    },
    methods:{
      updateMinPurchaseAuto(data){
        this.updateData({"field": "sales_minpurchase_auto_update", "value": data});
      },
      updateSalesPurchaseAuto(data){
        this.updateData({"field": "sales_purchase_auto_update", "value": data});
      },     
      updateSalesWeekpriceAuto(data){
        this.updateData({"field": "sales_weekprice_auto_update", "value": data});
      },                  
      updateData(data){
        this.$emit('updateData', data);      
      }      
    }    
  }
</script>

<style scoped>
  .sub-title{
    font-weight: bolder;
  }  
</style>